<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="icon-svg icon-information-circle"
  >
    <path
      d="M12,2c5.5142,0,10,4.4858,10,10s-4.4858,10-10,10S2,17.5142,2,12,6.4858,2,12,2ZM12,3.25C7.175,3.25,3.25,7.175,3.25,12s3.925,8.75,8.75,8.75,8.75-3.925,8.75-8.75S16.825,3.25,12,3.25ZM11.375,10.125c.6892,0,1.25.5608,1.25,1.25v3.125c0,.345.28.625.625.625h.625c.345,0,.625.28.625.625s-.28.625-.625.625h-.625c-1.0342,0-1.875-.8408-1.875-1.875v-3.125h-.625c-.345,0-.625-.28-.625-.625s.28-.625.625-.625h.625ZM11.6875,7c.5178,0,.9375.4197.9375.9375s-.4197.9375-.9375.9375-.9375-.4197-.9375-.9375.4197-.9375.9375-.9375Z"
    />
  </svg>
</template>
